var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_trash",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.787 66c0 5.5 4.5 10 10 10h28.1c5.5 0 10-4.5 10-10V19.8h-48.1V66zm4-42.2h40.1V66c0 3.3-2.7 6-6 6h-28.1c-3.3 0-6-2.7-6-6V23.8zm31.999-12V10c0-3.3-2.7-6-6-6h-11.9c-3.3 0-6 2.7-6 6v1.8h-16.1v4h56v-4h-16zm-4 0h-15.9V10c0-1.1.9-2 2-2h11.9c1.1 0 2 .9 2 2v1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.886 31.9h-4v32h4v-32zm9.9.1h-4v31.9h4V32zm10-.1h-4v32h4v-32z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrDelete);
export default __webpack_public_path__ + "static/media/ubr_delete.7ccf0f050e4f71cea3d67e97e78d34d9.svg";
export { ForwardRef as ReactComponent };